<div class=" access-modal">
  <div class=" access-modal-card">
    <div class="access-modal-header">
      <div class="access-modal-title">
        <i class="bi bi-buildings-fill access-icon"></i>
        {{ 'ASSOCIATION.SELECT_ASSOCIATION' | translate}}
      </div>
    </div>
    <div class="access-modal-body">
      <div class="container-fluid" *ngFor="let association of associations">
        <lwa-association-access-card
          [association]="association"
          (associationSelected)="selectAssociation($event)"></lwa-association-access-card>
      </div>
    </div>

  </div>

</div>
